import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { WorkProgressMaterialItem } from '../../interfaces/work-progress-material.interface';
import { DocumentNavigationComponent } from 'app/common/components/document-navigation/document-navigation.component';
import { UnifiedOrderBadgeComponent } from 'app/shared/components/unified-order-badge/unified-order-badge.component';

@Component({
  selector: 'app-document-navigation-wrapper-cell-renderer',
  standalone: true,
  imports: [CommonModule, DocumentNavigationComponent, UnifiedOrderBadgeComponent],
  template: `
    <div class="flex items-center gap-2">
      <app-document-navigation
        [documentType]="documentType"
        [documentSerial]="documentSerial"
        [displayText]="displayText"
        [showIcon]="showIcon">
      </app-document-navigation>

      <app-unified-order-badge
        *ngIf="hasSourceTransactions"
        [order]="orderData">
      </app-unified-order-badge>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentNavigationWrapperCellRendererComponent implements CellRenderer<WorkProgressMaterialItem> {
  @Input() params!: CellRendererParams<WorkProgressMaterialItem>;

  get documentType(): string {
    return this.params?.data?.originalDocument?.typeCode || '';
  }

  get documentSerial(): string {
    return this.params?.data?.documentNumber || '';
  }

  get displayText(): string {
    return this.params?.data?.documentNumber || '-';
  }

  get showIcon(): boolean {
    return !!this.params?.data?.documentNumber;
  }

  /**
   * Checks if the data has source transactions
   */
  get hasSourceTransactions(): boolean {
    // @ts-ignore - sourceTransactions may exist on extended data
    return !!(this.params.data?.originalDocument?.sourceTransactions?.length);
  }

  /**
   * Order data for the unified order badge
   */
  get orderData(): any {
    return {
      serial: this.documentSerial,
      // @ts-ignore - sourceTransactions may exist on extended data
      sourceTransactions: this.params.data?.originalDocument?.sourceTransactions,
      // @ts-ignore - operationType may exist on extended data
      operationType: this.params.data?.originalDocument?.operationType,
      // @ts-ignore - isUnified may exist on extended data
      isUnified: this.params.data?.originalDocument?.isUnified
    };
  }
}
